export default __webpack_public_path__ + "static/media/bitcoin-cash-logo.a31f8f5b.png";